import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCardMarkAsShipped } from "../../hooks/useCardMarkAsShipped";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";

interface MarkCardsAsShippedProps {
  ids: string[];
  clearSelectedItems: () => void;
}

const MarkCardsAsShipped = ({ ids, clearSelectedItems }: MarkCardsAsShippedProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: cardMarkAsShipped, isPending: cardMarkAsShippedIsPending } = useCardMarkAsShipped({
    onSuccess: () => {
      clearSelectedItems();
      setIsOpen(false);

      setIsError(false);
      setMessages(["Status dos cartões atualizados"]);
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setIsOpen(false);
        setIsError(true);
        setMessages(error.response?.data.errors.base);
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={() => cardMarkAsShipped(ids)}
        triggerDisabled={!ids.length}
        Trigger={(
          <Button
            className="text-nowrap"
            variant={ids.length ? "default" : "outline-disabled"}
            disabled={!ids.length}
            operationKlassToCheckPermission="Admin::Client::Cards::BulkMarkAsShipped"
          >
            Marcar envios dos cartões
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="bg-blue-700"
        confirmButtonText="Confirmar envio"
        showClose={false}
        disabled={cardMarkAsShippedIsPending}
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-white-400"
        title="Você tem certeza?"
        subtitle="Os cartões selecionados terão o status atualizado para Enviado."
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
          onClose={() => {
            queryClient.invalidateQueries({ queryKey: ['clientCardsInFabrication'] });
          }}
        />
      )}
    </>
  );
};

export default MarkCardsAsShipped;
